import LatLon from 'geodesy/latlon-spherical.js';
import { formatNum } from '@/util/number';
import { mapSeriesWithDatetime } from './shared';

export default {
  buildFields() {
    return [
      { key: 'datetime', label: 'Date Time', class: 'text-center' },
      { key: 'latitude', label: 'Latitude', class: 'text-center' },
      { key: 'longitude', label: 'Longitude', class: 'text-center' },
      { key: 'altitude', label: 'Altitude (m)', class: 'text-center' },
      { key: 'geoidal', label: 'Geoidal (m)', class: 'text-center' },
      { key: 'satellites', label: 'Satellites', class: 'text-center' },
      { key: 'track', label: 'Heading (°)', class: 'text-center' },
      { key: 'additional.AVG_dlgpSpeed_1', label: 'Speed (Knot)', class: 'text-center' },
      { key: 'additional.SUM_dlgpDistance_0', label: 'Distance (m)', class: 'text-center' },
      { key: 'waveHeight', label: 'Wave Height (m)', class: 'text-center' },
      { key: 'waveDir', label: 'Wave Dir (°)', class: 'text-center' },
      { key: 'wavePeriod', label: 'Wave Period (s)', class: 'text-center' },
      { key: 'relDir', label: 'Relative Dir (°)', class: 'text-center' },
      { key: 'wisScore', label: 'WIS Score', class: 'text-center' },
      { key: 'seaState', label: 'Sea State', class: 'text-center' },
      { key: 'refLatitude', label: 'Ref. Latitude', class: 'text-center' },
      { key: 'refLongitude', label: 'Ref. Longitude', class: 'text-center' },
      { key: 'refDistance', label: 'Ref. Distance (m)', class: 'text-center' },
      { key: 'refForecastDate', label: 'Ref. Forecast Date', class: 'text-center' },
    ];
  },
  buildLogs(seriesData) {
    return mapSeriesWithDatetime(seriesData, (serie) => ({
      additional: {
        ...serie.additional,
        SUM_dlgpDistance_0: formatNum(serie.additional.SUM_dlgpDistance_0, 2),
        AVG_dlgpSpeed_1: formatNum(serie.additional.AVG_dlgpSpeed_1, 2),
      },
    }));
  },
  buildSummary(seriesData) {
    const first = seriesData[0];
    const last = seriesData[seriesData.length - 1];
    const distance = new LatLon(first.latitude, first.longitude)
      .distanceTo(new LatLon(last.latitude, last.longitude));
    const totalCruise = seriesData.reduce((sum, serie) => sum + serie.additional.SUM_dlgpDistance_0, 0);
    const totalSpeed = seriesData.reduce((sum, serie) => sum + serie.additional.AVG_dlgpSpeed_1, 0);
    const averageSpeed = seriesData.length !== 0 ? totalSpeed / seriesData.length : 0;
    return { totalCruise, averageSpeed, distance };
  },
};
